import {
  IonButton,
  IonContent,
  IonIcon,
  IonPage,
  IonRouterLink,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonPopover,
  IonNote,
  useIonRouter,
} from "@ionic/react";
import Footer from "../Slides/Footer";
import { LandingHeader } from "../Slides/Landing";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { signIn } from "../../redux/actions/currentProfileActions";
import getFormData from "../../utils/getFormData";
import React, { useEffect, useState } from "react";
import { IonInput, IonItem, IonSpinner, IonText } from "@ionic/react";
import { DEFAULT_HOME_PATH } from "../../utils/constents";
import "./auth.css";
import { lockClosedOutline, personOutline } from "ionicons/icons";
import { CanadianButton } from "../../ui-components/CanadianButton";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";

const SigninForm = () => {
  const [showPassword, setShowPassword] = useState(false);

  const { i18n, t } = useTranslation();
  const router = useIonRouter();
  const dispatch = useDispatch();
  const { data, loading, errors } = useSelector(
    (state) => state.currentProfile,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    dispatch(signIn(formData));
  };

  useEffect(() => {
    if (data && !data.suspended) {
      window.location.href = DEFAULT_HOME_PATH;
    }
  }, [data]);

  return (
    <form onSubmit={handleSubmit} className="auth-form-container">
      <IonItem>
        <IonInput
          className="auth-input"
          data-testid="login-username-input"
          // label={t("username")}
          // labelPlacement="floating"
          placeholder={t("usernamePlaceholder2")}
          autocomplete="on"
          name="username"
          // fill="outline"
        >
          <IonIcon
            slot="start"
            icon={personOutline}
            aria-hidden="true"
          ></IonIcon>
        </IonInput>
      </IonItem>
      <IonItem>
        <IonInput
          className="auth-input"
          data-testid="login-password-input"
          // label={t("password")}
          // labelPlacement="floating"
          placeholder={t("passwordPlaceholder2")}
          autocomplete="on"
          required
          type={showPassword ? "text" : "password"}
          name="password"
          // fill="outline"
        >
          <IonIcon
            slot="start"
            icon={lockClosedOutline}
            aria-hidden="true"
          ></IonIcon>
        </IonInput>
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: "20px",
            top: "70%",
            transform: "translateY(-70%)",
            cursor: "pointer",
            zIndex: 10,
          }}
          data-testid="login-password-toggle"
        >
          {showPassword ? <FaRegEye size={18} /> : <FaEyeSlash size={18} />}
        </span>
      </IonItem>
      {/* {errors && errors[0]?.msg && (
        <IonText color="danger">
          <p className="auth-error-message">{errors[0].msg}</p>
        </IonText>
      )} */}
      {errors && errors[0]?.msg && (
        <div className="error-message-box" data-testid="login-error-message">
          <p className="error-text">{errors[0].msg}</p>
        </div>
      )}
      <IonButton
        type="submit"
        disabled={loading}
        // color="success"
        className="auth-submit-button"
        data-testid="login-submit-button"
      >
        {loading ? <IonSpinner name="dots" /> : t("signin_button")}
      </IonButton>
      {/* New Remember Me & Forgot Password Row */}
      <div className="auth-forgot-password-wrapper">
        <IonRouterLink
          color="secondary"
          routerLink="/forgot-password"
          className="auth-forgot-password-link"
          data-testid="login-forgot-password-link"
        >
          {t("forgotPassword")}
        </IonRouterLink>
      </div>
      <hr className="auth-separator" />
      <CanadianButton
        type="button"
        data-testid="login-signup-button"
        onClick={() => router.push("/signup")}
      >
        {/* {t("noAccount")} */}
        Sign up
      </CanadianButton>
    </form>
  );
};

const Signin2 = () => {
  const { i18n, t } = useTranslation();
  return (
    <IonPage>
      <LandingHeader />

      <IonContent fullscreen className="auth-content">
        <div className="auth-wrapper">
          {/* hero  */}
          <img
            src="/landing-page-banner.svg"
            alt="hero"
            className="landing-page-banner hide-on-mobile"
          />
          <div className="auth-hero">
            <div className="show-on-mobile">
              <h2 className="auth-signin-header poetsen">{t("signin")}</h2>
            </div>
            <div className="auth-main-container">
              <div className="auth-left-column hide-on-mobile">
                <div className="auth-text-wrapper">
                  <h1 className="auth-hero-title">{t("signin2.heroTitle")}</h1>
                  <p className="auth-hero-description">
                    {t("signin2.heroDescription")}
                  </p>
                </div>
              </div>
              <div className="auth-form-box">
                <h2 className="auth-signin-header hide-on-mobile poetsen">
                  {t("signin")}
                </h2>
                <SigninForm />
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Signin2;
